export default "__VITE_PUBLIC_ASSET__3c83ed42__"